<div *ngIf="cumulative">
    <ion-col size-md="6" size-xs="12">
        <ion-card class="card-compare">
            <ion-card-header>Cumulative
                [{{ compareManager.compareDates[0] | date:'yyyy-MM-dd HH:mm' }}
                - {{ compareManager.compareDates[compareManager.compareDates.length - 1] | date:'yyyy-MM-dd HH:mm' }}]
            </ion-card-header>
            <ion-card-content *ngIf="compareManager.globalComparePoints?.length">
                <raain-compare
                        (selectedPoint)="onClick($event)"
                        [compareIndex]="0"
                        [currentHeight]="500"
                        [pointMax]="compareManager.globalComparePointsMax"
                        [points]="compareManager.globalComparePoints"></raain-compare>
            </ion-card-content>
        </ion-card>
    </ion-col>

    <ion-button (click)="exportCumulativeToCsv()" *ngIf="compareManager.globalComparePoints?.length" fill="outline" size="small">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        Export CSV
    </ion-button>
</div>

<div *ngIf="!cumulative">
    <ion-col *ngFor="let compare of  compareManager?.uiCompares; index as compareIndex" size-md="6" size-xs="12">
        <ion-card class="card-compare">
            <ion-card-header>Gauges filled {{ compare.name }} {{ compare.remarks }}
            </ion-card-header>
            <ion-card-content *ngIf="compare.comparePoints?.length">
                <raain-compare
                        (selectedPoint)="onClick($event)"
                        [compareIndex]="compareIndex"
                        [currentHeight]="500"
                        [pointMax]="compare.comparePointsMax"
                        [points]="compare.comparePoints"></raain-compare>
            </ion-card-content>
        </ion-card>
    </ion-col>

    <ion-button (click)="exportGranularToCsv()" *ngIf="compareManager.uiCompares?.length" fill="outline" size="small">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        Export CSV
    </ion-button>
</div>
